var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEdit28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 25L25.1716 8.82843C26.7337 7.26633 26.7337 4.73368 25.1716 3.17158L24.8285 2.82844C23.2664 1.26634 20.7337 1.26634 19.1716 2.82843L3 19L3.00003 24.9203L9.00003 25ZM23.7574 4.58579L23.4142 4.24265C22.6332 3.4616 21.3669 3.4616 20.5858 4.24265L19.1213 5.70716L22.2929 8.87873L23.7574 7.41422C24.5384 6.63317 24.5384 5.36684 23.7574 4.58579ZM20.8787 10.2929L17.7071 7.12137L7.93936 16.8891L11.1109 20.0607L20.8787 10.2929ZM5 19.8284L6.52514 18.3033L9.69673 21.4749L8.18263 22.989L5.00002 22.9467L5 19.8284Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;